export const productList = (state) => {
    return state.products
}

